<script setup>
import WarningIcon from '@iconify-vue/ph/warning-fill';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';

const { align = 'left', color = 'red' } = defineProps({
    align: {
        type: String,
        required: false,
    },
    color: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <BaseCell :align="align">
        <WarningIcon
            class="size-5"
            :class="{
                'text-green-500': color === 'green',
                'text-yellow-500': color === 'yellow',
                'text-red-500': color === 'red',
            }"
        />
    </BaseCell>
</template>
